import cx from 'classnames';
import React, { useState } from 'react';

import { ReactComponent as SmartbeLogo } from '../../assets/icons/SmartbeLogo.svg';
import s from './index.module.css';

const WidgetFooter = () => {
  const [isSmartbeLogoHovered, setIsLogoHovered] = useState(false);

  const handleMouseOverLogo = () => {
    if (!isSmartbeLogoHovered) {
      setIsLogoHovered(true);
    }
  };

  const handleMouseLeaveLogo = () => {
    if (isSmartbeLogoHovered) {
      setIsLogoHovered(false);
    }
  };

  return (
    <div className={s.widgetFooter}>
      <div className={s.smartbeLabel}>Работает на технологии</div>
      <a className={s.logoWrapper} href="https://smartbe.ru/Business" target="_blank" rel="noopener noreferrer">
        <SmartbeLogo
          className={cx(s.smartbeLogo, {
            [s.smartbeLogoHovered]: isSmartbeLogoHovered,
          })}
          onMouseEnter={handleMouseOverLogo}
          onMouseLeave={handleMouseLeaveLogo}
        />
      </a>
    </div>
  );
};

export default WidgetFooter;
